import React from "react";
import { FaTruck, FaMoneyBillWave, FaHeadset } from "react-icons/fa";
import "./FeatureCards.css"; // Import custom styles

const FeatureCards = () => {
  const features = [
    {
      id: 1,
      icon: <FaTruck />,
      title: "Free Shipping From ₦150,000",
      description:
        "Enjoy unmatched convenience with our free shipping policy! Orders worth ₦150,000 or more qualify for free delivery to your doorstep.",
    },
    {
      id: 2,
      icon: <FaMoneyBillWave />,
      title: "Money-Back Guarantee",
      description:
        "Shop with confidence! We offer a money-back guarantee on all our products. If you're not satisfied, get a refund or replacement easily.",
    },
    {
      id: 3,
      icon: <FaHeadset />,
      title: "Support 24/7",
      description:
        "We’re here for you anytime, anywhere. Our support team is available 24/7 to assist with your orders, inquiries, or any concerns.",
    },
  ];

  return (
    <div className="feature-cards-container">
      {features.map((feature) => (
        <div key={feature.id} className="feature-card"
        data-aos="fade-up">
          <div className="icon">{feature.icon}</div>
          <h3 className="feature-title">{feature.title}</h3>
          <p className="feature-description">{feature.description}</p>
        </div>
      ))}
    </div>
  );
};

export default FeatureCards;
